export default __webpack_public_path__ + "static/media/organisations.05707d8e.svg";